import React, { Suspense, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
  withRouter
} from "react-router-dom";
import ScrollToTop from "./scrollToTop";
import LoaderWrapper from "./loaderWrapper";
import "../assets/styles/common.scss";
import Loader from "../views/common/loader";
import { postSessionStart } from "../utils";
import { useSelector } from "react-redux";
import axios from "axios";
import LeadCaptureSuccessPage from "../views/journey/openMarket/LeadCaptureSuccess";
const ErrorPage = React.lazy(() => import("../views/common/error"));
const DRCErrorPage = React.lazy(() => import("../views/common/drcError"));
const RSMErrorPage = React.lazy(() => import("../views/common/rsmError"));
const DropPage = React.lazy(() => import("../views/common/drop"));
const OpenMarketForm = React.lazy(() =>
  import("../views/journey/openMarket/form")
);
const OffersPage = React.lazy(() =>
  import("../views/journey/openMarket/offers")
);
const WelcomePage = React.lazy(() => import("../views/journey/welcome"));
const BasicDetails = React.lazy(() => import("../views/journey/basicDetails"));
const NrDetails = React.lazy(() => import("../views/journey/nrDetails"));
const PlanDetailsPage = React.lazy(() =>
  import("../views/journey/planDetails")
);
const DeclarationPage = React.lazy(() =>
  import("../views/journey/declarations")
);
const NomineePage = React.lazy(() => import("../views/journey/nomineeDetails"));
const PaymentPage = React.lazy(() => import("../views/journey/payment"));
const PaymentSuccessPage = React.lazy(() =>
  import("../views/journey/payment/success")
);
const PaymentFailurePage = React.lazy(() =>
  import("../views/journey/payment/failure")
);
const SummaryPage = React.lazy(() => import("../views/journey/summary"));
const CustAuthPage = React.lazy(() => import("../views/journey/custAuth"));
const ServerDownPage = React.lazy(() => import("../views/common/serverDown"));
const BankingForm = React.lazy(() => import("../views/enach/index"));

const HbankIframe = React.lazy(()=> import("../views/iframe/quote/index"))


const OtpPrefill =  React.lazy(() => import("../views/journey/otpPrefill"));
const HBankEmp =  React.lazy(() => import("../views/journey/hbankEmp"));

const Productcard =  React.lazy(() => import("../views/iframe/offers/Productcard"));

function WaitingComponent(Component) {
  return (props) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
}

function AppRouter({ ...props }) {
  const urlParams = new URLSearchParams(window?.location?.search);
  const _diy = urlParams.get("diy");


// useEffect(() => {
//   const parentDomain = window.top['0'].location.ancestorOrigins?.['0']
//   if (parentDomain == "http://localhost:3000") setIsHbankApp(true);
// }, []);
  return (
    <LoaderWrapper>
      <div className="router-layout" >
        <div >
          <Router>
            <ScrollToTop>
              {_diy?.toLowerCase() === 'yes' ?
             <Switch>
                 <Route
                  path="/open-market/form/:partner/:channel"
                  component={WaitingComponent(OpenMarketForm)}
                />
             
                  <Route
                  path="/diyoffers"
                  component={WaitingComponent(Productcard)}
                />
                <Route
                  path="/quote/"
                  component={WaitingComponent(HbankIframe)}
                  name="landing"
                />
                 <Route
                  path="/"
                  component={WaitingComponent(Productcard)}
                  name="landing"
                />
                <Route
                  path="*"
                  component={WaitingComponent(Productcard)}
                  name="landing"
                />
                
             </Switch>
             : <Switch>
                <Route
                  path="/service-down"
                  component={WaitingComponent(ServerDownPage)}
                />
                 {/* <Route
                  path="/enach"
                  component={WaitingComponent(PaymentPage)}
                /> */}
                 <Route
                  path="/enach/:aNum"
                  component={WaitingComponent(BankingForm)}
                />
                <Route
                  path="/error/:errorType/:drop_reason"
                  component={WaitingComponent(ErrorPage)}
                />
                <Route
                  path="/LeadCapture"
                  component={WaitingComponent(LeadCaptureSuccessPage)}
                />
                <Route path="/error" component={WaitingComponent(ErrorPage)} />
                <Route
                  path="/drc/error"
                  component={WaitingComponent(DRCErrorPage)}
                />
                <Route
                  path="/rsm/error"
                  component={WaitingComponent(RSMErrorPage)}
                />
                <Route
                  path="/drop/:drop_source/:drop_reason"
                  component={WaitingComponent(DropPage)}
                />
                <Route path="/drop" component={WaitingComponent(DropPage)} />
                <Route
                  exact
                  path="/payment/failure"
                  component={WaitingComponent(PaymentFailurePage)}
                />
                <Route
                  exact
                  path="/payment/success"
                  component={WaitingComponent(PaymentSuccessPage)}
                />
                <Route
                  exact
                  path="/payment/:product/:partner/:id"
                  component={WaitingComponent(PaymentPage)}
                />
                 <Route
                  exact
                  path="/payment/:product/:partner/:id/:enachStatus"
                  component={WaitingComponent(PaymentPage)}
                />
                <Route
                  exact
                  path="/application/summary/:product/:partner/:id/:appno"
                  component={WaitingComponent(SummaryPage)}
                />
                <Route
                  exact
                  path="/cust/auth/:partner/:product"
                  component={WaitingComponent(CustAuthPage)}
                />
                <Route
                  exact
                  path="/nominee/:product/:partner/:id"
                  component={WaitingComponent(NomineePage)}
                />
                <Route
                  exact
                  path="/declarations/:product/:partner/:id"
                  component={WaitingComponent(DeclarationPage)}
                />
                <Route
                  exact
                  path="/quote/:product/:partner/:id"
                  component={WaitingComponent(PlanDetailsPage)}
                />
                 <Route
                  exact
                  path="/quote/:product/:partner/:id/:PP2S"
                  component={WaitingComponent(PlanDetailsPage)}
                />
                <Route
                  exact
                  path="/basic-details/:product/:partner/:id"
                  component={WaitingComponent(BasicDetails)}
                />
                <Route
                  exact
                  path="/OtpPrefill/:product/:partner/:id"
                  component={WaitingComponent(OtpPrefill)}
                />
                <Route
                  exact
                  path="/basic-details/nr/:product/:partner/:id"
                  component={WaitingComponent(NrDetails)}
                />
                <Route
                  path="/open-market/offers/:partner/:channel/:id"
                  component={WaitingComponent(OffersPage)}
                />
                <Route
                  path="/open-market/form/:partner/:channel"
                  component={WaitingComponent(OpenMarketForm)}
                />
                  <Route
                  exact
                  path="/hbankemp/form/:partner"
                  component={WaitingComponent(HBankEmp)}
                />
                <Route
                  path="/"
                  component={WaitingComponent(WelcomePage)}
                  name="landing"
                />
                {/* <Route
                  path="*"
                  component={WaitingComponent(WelcomePage)}
                  name="landing"
                /> */}
              </Switch>}
            </ScrollToTop>
          </Router>
        </div>
      </div>
      <SessionStart />
    </LoaderWrapper>
  );
}

const SessionStart = (second) => {
  const StoreData = useSelector((state) => state);
  const {
    pasaStore: { journey, source, custId, product }
  } = StoreData;

  if (product && custId && source && ["HBANK", "HBANKOM","RTL_HBANK","LEAD_CAPTURE","CROSS_SELL","SELFSOURCE","NONHBANKC2PSNSPECIALPASA","SELFSOURCENONHBANK", "EDM","DIRECT_AG","HDFC_SEC","NH_DIRECT", "DIRECTCHANNEL"].includes(source?.toUpperCase())) {
    axios.defaults.headers.common["x-server-api-key"] =
      process.env[
      `REACT_APP_API_KEY_${product?.toUpperCase()}_${source?.toUpperCase()}`
      ];
  }

  useEffect(() => {
    if (product && custId && source && ["HBANK", "HBANKOM","RTL_HBANK","LEAD_CAPTURE","CROSS_SELL","SELFSOURCE","NONHBANKC2PSNSPECIALPASA","SELFSOURCENONHBANK", "EDM","DIRECT_AG","HDFC_SEC","NH_DIRECT", "DIRECTCHANNEL"].includes(source?.toUpperCase())) {
      postSessionStart(product, custId, source);
    }
  }, []);
  return null;
};
export default AppRouter;
